export const sizeString = (size, sizes) => {
    for (let i = 0; i < sizes.length; i++) {
        if (sizes[i] >= size) {
            return sizes[i] + '/';
        }
    }
    return sizes[sizes.length - 1] + '/';
}